<div
	class="kp-flex-layout {{(panel=='employer' ? 'kp-flex-layout-dark' : (panel=='news'? 'kp-flex-layout-dark-blue' : ''))}}"
	[class.d-flex]="!isMobile && expandedMenu">
	<section class="kp-flex-menu" [class.kp-flex-menu-compact]="!isMobile && expandedMenu && !menuOpen"
		[class.kp-flex-menu-expanded]="!isMobile && expandedMenu" [class.kp-flex-menu-open]="menuOpen">
		<div class="kp-flex-menu-body relative">
			<header [class.x-light-gray-bg]="panel!='employer'" (click)="menuOpen=!menuOpen">
				<i class="fa fs-xxl relative" [class.fa-bars]="!menuOpen" [class.fa-times]="menuOpen">
					<i class="fas fa-circle f-red new-version fs-lg relative" style="top:-10px; left: 10px"
						*ngIf="newVersion"></i>
				</i>
			</header>
			<ng-container *ngTemplateOutlet="menuItems"></ng-container>
			<ng-container *ngTemplateOutlet="menuFooter"></ng-container>

			<div *ngIf="newVersion && menuOpen" class="mask-local z-2 d-flex pt-5 align-items-start justify-content-center"
				(click)="$event.stopPropagation()">
				<button class="btn btn-green" (click)="reload()">
					<i class="fas fa-asterisk ml-2"></i>
					بارگذاری نسخه جدید
				</button>
			</div>

		</div>
		<div class="kp-flex-menu-scrim" (click)="menuOpen=false"></div>
	</section>
	<div class="w-100 {{noScroll? 'vh-100 d-flex flex-column overflow-hidden' : 'flex-fill'}}"
		[class.x-light-gray-bg]="panel=='employer'">
		<header class="flex-header">
			<div class="menu-toggle pointer" *ngIf="!expandedMenu" (click)="menuOpen=true">
				<i class="fa fa-bars fs-xxl relative">
					<i class="fas fa-circle f-red new-version fs-lg relative" style="top:-10px; left: 10px"
						*ngIf="newVersion"></i>
				</i>
			</div>
			<div class="flex-fill justify-content-between mx-md-3">
				<nav>
					<ng-container *ngTemplateOutlet="quickLinkSection"></ng-container>
				</nav>
				<nav class="d-none d-md-flex">
					<!-- <a class="mx-2" ga-event="menu|job-list" [routerLinkActive]="['active']" routerLink="/job">
            <i class="fa fa-search fs-lg m-0 ml-1"></i>
            فرصت‌های شغلی</a> -->
				</nav>
			</div>
			<div class="d-flex align-items-center">
				<ng-container *ngTemplateOutlet="profileSection"></ng-container>
			</div>
		</header>
		<app-global-banner></app-global-banner>
		<section class="{{noScroll? 'flex-fill overflow-hidden' : 'h-min-full-header'}}  relative d-flex flex-column"
			[class.container]="!fluid && !homepage && panel != 'admin'" [class.px-0]="panel != 'admin'"
			[class.px-1]="panel == 'admin'" [class.compact-margin]="false && !isMobile && !expandedMenu"
			[class.pt-md-3]="panel=='employer'">
			<ngx-spinner [fullScreen]="false" type="timer"></ngx-spinner>
			<router-outlet></router-outlet>
		</section>
		<app-footer *ngIf="Utility.showFooter"></app-footer>

	</div>
</div>

<ng-template #notificationSection>
	<div class="ml-2" *ngIf="user">
		<i class="fa fa-bookmark fs-xl relative pointer" routerLink="/favorite" title="نشان شده‌ها"></i>
	</div>
	<div class="ml-2" *ngIf="user">
		<i class="fa fa-bell fs-xl relative pointer" (click)="openNotificationPanel()"
			[ngSwitch]="pushService.status$|async">
			<i class="fas fa-times f-red new-version fs-sm absolute" style="top:-5px; right: -4px"
				*ngSwitchCase="'messaging/unsupported-browser'"></i>
			<i class="fas fa-times f-red new-version fs-sm absolute" style="top:-5px; right: -4px"
				*ngSwitchCase="'messaging/permission-blocked'"></i>
			<ng-container *ngSwitchCase="'messaging/permission-allowed'">
				<i *ngIf="user?.HasOverduePush" class="fas fa-circle f-red new-version fs-sm absolute"
					style="top:-5px; right: -4px"></i>
			</ng-container>
			<i class="fas fa-circle f-red new-version fs-sm absolute" style="top:-5px; right: -4px" *ngSwitchDefault></i>
		</i>
	</div>
	<a class="d-block pointer ml-2" *ngIf="user?.IsStaff" routerLink="/admin/activity">
		<i class="fa fa-tasks fs-xl relative">
			<span class="reset-fa red-bg f-white fs-sm relative rounded" style="right: .5em;top:-1em;padding:.25em"
				*ngIf="activityService.toDo$|async">{{activityService.toDo$|async}}</span>
		</i>
	</a>
	<a class="d-block pointer ml-2" *ngIf="user?.Operator" routerLink="/admin/message">
		<i class="fa fa-sms fs-xl"></i>
	</a>

	<ng-container *ngIf="user?.UnreadChats || user?.IsStaff">
		<a class="d-block pointer ml-2" routerLink="/chat" title="چاپار">
			<i class="fa fa-comments fs-xl relative">
				<div *ngIf="ChatService.unreadChatCount || ChatService.dueTodoCount"
					class="reset-fa badge f-white badge-pill fs-xs absolute" style="top:-5px; right: -4px"
					[class.blue-bg]="ChatService.unreadChatCount" [class.red-bg]="!ChatService.unreadChatCount">
					{{ChatService.unreadChatCount||ChatService.dueTodoCount}}</div>
			</i>
		</a>
		<a class="d-block pointer ml-2" (click)="sharedService.eventBus$.next({type:'open-chat'})"
			*ngIf="true || !user?.IsStaff && showSupport">
			<i class="fa fa-headphones f-green fs-xl"></i>
		</a>
	</ng-container>

	<div class="fixed-fill z-infinit white-bg d-flex flex-column" *ngIf="showNotificationPanel"
		[ngSwitch]="pushService.status$|async">
		<div>
			<div class="d-inline-block pointer p-2" (click)="showNotificationPanel=false">
				<i class="fa fa-times fs-xxl"></i>
			</div>
		</div>

		<div class="flex-fill overflow-auto">
			<div class="container-capped">
				<div *ngSwitchCase="null">
					<div class="text-center">
						<img src="/assets/images/KarpisheLogo.svg" style="height:40px" alt="کارپیشه" title="کارپیشه">
						<h1 class="my-3">گاهی پیش میاد!؛</h1>
					</div>
					<ul class="list-bullet">
						<ng-container *ngIf="user?.Seeker">
							<li>آگهی جدید مرتبط باهات پیدا می‌شه</li>
							<li>یه کارفرما رزومه‌ت رو می‌بینه و ازت دعوت به همکاری می‌کنه</li>
						</ng-container>
						<ng-container *ngIf="user?.Employer">
							<li>یکی که به دردت می‌خوره، آگهی شما رو قبول می‌کنه</li>
							<li>یکی از رزومه‌هایی که خریدی جواب داده</li>
						</ng-container>
						<li>اتفاقی اینجا می‌افته که باید سریع خبرت کنیم!</li>
					</ul>
					پس برای اینکه بتونیم اتفاق‌های مهم رو سریع بهت خبر بدیم،
					<div class="p-3 text-center">
						<button class="btn btn-primary w-100" (click)="requestNotificationPermission()">
							اطلاع‌رسانی سریع رو فعال کن
						</button>
					</div>
				</div>
				<div *ngSwitchCase="'messaging/permission-blocked'">
					<div class="kp-message kp-message-warning">
						متاسفانه شما اطلاع‌رسانی سریع رو برای کارپیشه بستین.<br />
						لطفا از آیکون قفل بالای نوار آدرس انتخاب دسترسی‌(Permission)های خود را تغییر دهید.
					</div>
				</div>
				<div *ngSwitchCase="'messaging/unsupported-browser'">
					<div class="kp-message kp-message-warning">
						دستگاه شما امکان اطلاع‌رسانی سریع ندارد!
					</div>
				</div>
				<div *ngSwitchCase="'messaging/permission-allowed'">
					<div class="kp-message kp-message-success">
						<i class="fa fa-check fs-lg ml-2"></i>
						اطلاع‌رسانی سریع فعال است!
					</div>
				</div>
				<div *ngIf="messages?.length">
					<h6>آخرین پیام‌های دریافتی</h6>
					<div class="fs-sm kp-card mx-0" *ngFor="let message of messages">
						<div class="d-flex align-items-center justify-content-between">
							<div class="flex-fill">
								<ng-container [ngSwitch]="message.Channel">
									<ng-container *ngSwitchCase="0">نوتیفیکیشن</ng-container>
									<ng-container *ngSwitchCase="1">پیامک</ng-container>
									<ng-container *ngSwitchCase="2">ایمیل</ng-container>
									<ng-container *ngSwitchDefault></ng-container>
								</ng-container>
							</div>
							<div>{{message.SentDate|pdate}}</div>
						</div>
						<div class="text-justify pre-wrap">
							<a [attr.href]="message.Link||undefined">
								<ng-container *ngIf="message.Title">
									{{message.Title}}
									<hr />
								</ng-container>
								{{message.SentMessage || message.Text}}
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</ng-template>
<ng-template #profileSection>
	<ng-container *ngTemplateOutlet="notificationSection"></ng-container>

	<!-- <a *ngIf="!user" class="btn btn-secondary btn-sm align-self-center pt-0 px-3 mx-2 ml-md-3 fsp-1"
    routerLink="/login">ورود</a> -->
	<div class="abs-fill z-2 kp-blur-bg" *ngIf="profileOpen" (click)="profileOpen=false"></div>
	<div *ngIf="user" class="h-100 relative ml-md-3">
		<div (click)="profileOpen=true" [class.hidden]="profileOpen"
			class="d-flex align-items-center justify-content-end pointer yellow-bg-hover f-dark-gray-hover h-100 px-3 px-md-5 no-wrap">
			<i class="fa fa-user-circle fs-xxl"></i>
			<span class="d-none d-md-block mr-2">{{user.Name || user.Username}}</span>
		</div>
		<div class="absolute top-0 left-0 f-initial" *ngIf="profileOpen" style="z-index: 1000;">
			<div class="d-flex align-items-center justify-content-center yellow-bg f-dark-gray h-header px-3 px-md-5  no-wrap"
				[class.rounded-top-right-xl]="Utility.mobile">
				<i class="fa fa-user-circle fs-xxl"></i>
				<span class="mr-2">{{user.Name || user.Username}}</span>
			</div>
			<div class="x-light-gray-bg rounded-bottom-xl px-3 py-2 text-center no-wrap">
				<div class="my-2">0{{user.Username}}</div>
				<div class="my-2" *ngIf="user.Seeker?.Email">{{user.Seeker?.Email}}</div>

				<div class="my-2" *ngIf="user.Seeker?.KarpashaProgress">
					<a routerLink="/karpasha/status" (click)="profileOpen = false" class="btn btn-primary btn-sm py-1 w-100 ">
						پرونده کاریابی</a>
				</div>
				<div class="my-2" *ngIf="user.Seeker?.IsAcceptable">
					<a routerLink="/seeker/profile" [queryParams]="{tab:'resume'}" (click)="profileOpen = false"
						class="btn btn-secondary btn-sm py-1 w-100 ">
						رزومه من</a>
				</div>

				<div class="my-2" *ngIf="!user.Employer && !user.Seeker?.IsAcceptable">
					<div *ngIf="!user.Seeker?.IsAcceptable" class="p-1 fs-sm pre-wrap">
						اگر دنبال کار می‌گردید وارد بخش ثبت رزومه شوید.
					</div>
					<a routerLink="/seeker/profile" (click)="profileOpen = false" class="btn btn-secondary btn-sm w-100 ">
						ثبت رزومه</a>
				</div>
				<div class="my-2 d-flex flex-column"
					*ngIf="user.Karpasha || user.Operator?.AccessRights?.includes('ManageLeads')">
					<a routerLink="/karpasha" (click)="profileOpen = false"
						class="btn btn-secondary btn-sm py-1 w-100 f-white dark-gray-bg mb-1">
						کارپاشا</a>
				</div>
				<div class="my-2 d-flex flex-column"
					*ngIf="user.Operator"> 
					<a [href]="labsUrl + '/?kp-sid='+ token"
					target="_blank"
					rel="noopener noreferrer"
					class="btn btn-secondary btn-sm py-1 w-100 f-white dark-gray-bg">
						کارپیشه لبز
					</a>
					</div>

				<div class="my-2" *ngIf="user.Employer">
					<!-- <div *ngIf="!user.Employer" class="p-1 fs-sm pre-wrap">
            اگر می‌خواهید کسی را استخدام کنید وارد بخش کارفرمایان شوید
          </div> -->
					<a routerLink="/employer/ads" (click)="profileOpen = false"
						class="btn btn-secondary btn-sm py-1 w-100 f-white dark-gray-bg">
						بخش کارفرمایان</a>
					<div *ngIf="user.Credit" class="fs-sm mt-1">
						<i class="fa fa-plus fs-lg f-green ml-1"></i>
						{{user.Credit | number}} تومان اعتبار ثبت آگهی
					</div>
					<!-- <div *ngIf="user.ResumeCredit" class="fs-sm mt-1">
            <i class="fa fa-plus fs-lg f-green ml-1"></i>
            {{user.ResumeCredit}} عدد اعتبار خرید رزومه
          </div> -->
				</div>
				<div class="my-2">
					<div class="btn btn-secondary btn-sm w-100 my-1 py-1 f-white red-bg" (confirm)="logout()">خروج</div>
				</div>
				<div>
					<div class="px-2 text-center">
					</div>

				</div>

			</div>

		</div>

	</div>

</ng-template>
<ng-template #quickLinkSection>
	<ng-container [ngSwitch]="panel">
		<!-- <ng-container *ngSwitchCase="'employer'">
      <a class="nav-brand" routerLink="/employer/seekers">
        <img src="/assets/images/logo/karpishe-employer.svg" alt="کارفرمایان  کارپیشه" title="کارفرمایان  کارپیشه">
      </a>
    </ng-container> -->
		<ng-container *ngSwitchCase="'news'">
			<a class="nav-brand" routerLink="/news">
				<img src="/assets/images/KarpisheIcon.svg" alt="اخبار استخدام" title="اخبار استخدام">
				<span class="fs-lg mr-1 fw-bold no-wrap-ellipsis">اخبار استخدام</span>
			</a>
		</ng-container>
		<ng-container *ngSwitchDefault>
			<a *ngIf="homepage" ga-event="menu|job-list" [routerLinkActive]="['active']" routerLink="/job"
				class="no-wrap-ellipsis ml-2">
				<i class="fa fa-search fs-lg m-0 mx-2"></i></a>
			<a *ngIf="!homepage" class="nav-brand px-2" routerLink="/" [class.light-gray-bg]="panel=='employer'">
				<img src="/assets/images/KarpisheLogo.svg" style="width:100px;height:24px" alt="کارپیشه" title="کارپیشه">
			</a>
			<a *ngIf="panel!='admin' && !user" class="ml-1 mr-auto btn btn-blue align-self-center" routerLink="/hire">
				ثبت آگهی استخدام</a>
			<a *ngIf="panel!='admin' && user" class="nav-brand mr-auto ml-1 fw-bold" routerLink="/employer/ads">بخش
				کارفرمایان</a>
		</ng-container>
	</ng-container>

</ng-template>
<ng-template #menuItems>
	<nav (click)="!expandedMenu && menuOpen=false">
		<ng-container *ngIf="panel!='employer'">
			<a class="menu-item" *ngIf="!user"
				[routerLinkActive]="['menu-active']" routerLink="/login" title="ورود به پنل">
				<i class="fa fa-user-circle fs-xl"></i>
				<span class="menu-title">ورود به پنل</span>
			</a>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/job" title="استخدام">
				<i class="fa fa-search fs-xl"></i>
				<span class="menu-title">استخدام</span>
			</a>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/ready-to-work" title="آماده به کار">
				<i class="fa fa-search fs-xl"></i>
				<span class="menu-title">آماده به کار</span>
			</a>
			<ng-container *ngIf="!user?.Employer && !user?.Seeker?.IsAcceptable">
				<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/seeker" title="ثبت رزومه">
					<i class="fa fa-user-plus fs-xl"></i>
					<span class="menu-title">ثبت رزومه</span>
				</a>
			</ng-container>
			<ng-container *ngIf="user?.Seeker">
				<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/seeker/profile"
					[queryParams]="{tab:'resume'}" title="رزومه من">
					<i class="fa fa-file fs-xl"></i>
					<span class="menu-title">رزومه من</span>
				</a>
				<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/seeker/profile"
					[queryParams]="{tab:'applies'}" title="رزومه‌های ارسال شده">
					<span class="icon-easy-apply-transparent icon-sm"></span>
					<span class="menu-title">رزومه‌های ارسال شده</span>
				</a>
				<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/seeker/matching"
					title="شغل‌های گوش به زنگ">
					<i class="fa fa-bell fs-xl"></i>
					<span class="menu-title">شغل‌های گوش به زنگ</span>
				</a>
			</ng-container>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/account/rtw" title="ثبت آگهی آماده به کار">
				<i class="fa fa-plus fs-xl"></i>
				<span class="menu-title">ثبت آگهی آماده به کار</span>
			</a>
			<a *ngIf="!user?.Seeker || user?.Employer" class="menu-item" [routerLinkActive]="['menu-active']"
				routerLink="/employer/postad/flatrate" title="ثبت آگهی استخدام">
				<i class="fa fa-plus fs-xl"></i>
				<span class="menu-title">ثبت آگهی استخدام</span>
			</a>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/favorite" title="نشان شده‌ها">
				<i class="fa fa-bookmark fs-xl"></i>
				<span class="menu-title">نشان شده‌ها</span>
			</a>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/discussion" title="تبادل نظر">
				<i class="fa fa-comment-dots fs-xl"></i>
				<span class="menu-title">تبادل نظر</span>
			</a>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/resource" title="منابع ارتقای شغلی">
				<i class="fa fa-search fs-xl"></i>
				<span class="menu-title">منابع ارتقای شغلی</span>
			</a>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/resource/course" title="دوره آموزشی">
				<i class="fa fa-search fs-xl"></i>
				<span class="menu-title">دوره آموزشی</span>
			</a>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/resource/article" title="مقاله">
				<i class="fa fa-search fs-xl"></i>
				<span class="menu-title">مقاله</span>
			</a>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/resource/book" title="کتاب">
				<i class="fa fa-search fs-xl"></i>
				<span class="menu-title">کتاب</span>
			</a>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/resource/template" title="فایل‌ و‌ قالب">
				<i class="fa fa-search fs-xl"></i>
				<span class="menu-title">فایل‌و‌قالب</span>
			</a>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/resource/software" title="نرم‌افزار">
				<i class="fa fa-search fs-xl"></i>
				<span class="menu-title">نرم‌افزار</span>
			</a>
			<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/news" title="اخبار استخدام">
				<span class="icon-sm bg-contain"
					style="background-image: url(https://www.estekhtam.com/wp-content/uploads/2018/06/cropped-logo-32x32.png);"></span>
				<span class="menu-title">اخبار استخدام</span>
			</a>



			<a class="menu-item" href="https://blog.karpishe.com/" target="_blank" title="بلاگ کارپیشه"
				(click)="$event.stopPropagation()">
				<i class="fa fa-pen-nib fs-xl"></i>
				<span class="menu-title">بلاگ کارپیشه</span>
			</a>
			<ng-container *ngIf="!user?.Seeker || user?.Employer">
				<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/employer/seekers"
					title="جستجوی کارجویان (رزومه)">
					<i class="fa fa-address-book fs-xl"></i>
					<span class="menu-title">جستجوی کارجویان (رزومه)</span>
				</a>
			</ng-container>
			<ng-container *ngIf="user?.Employer">
				<a class="menu-item f-white dark-gray-bg" [routerLinkActive]="['menu-active']" routerLink="/employer/applies"
					title="بخش کارفرمایان">
					<i class="fa fa-bullhorn fs-xl"></i>
					<span class="menu-title">بخش کارفرمایان</span>
				</a>
			</ng-container>
			<ng-container *ngIf="!user?.Employer">
				<a class="menu-item f-white dark-gray-bg" [routerLinkActive]="['menu-active']" routerLink="/employer"
					title="بخش کارفرمایان">
					<i class="fa fa-bullhorn fs-xl"></i>
					<span class="menu-title">بخش کارفرمایان</span>
				</a>
			</ng-container>

			<ng-container *ngIf="user?.Agent">
				<div class="kp-title-line">
					کاریابی
				</div>
				<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/agent/ads/save" title="درج آگهی کاریابی">
					<i class="fa fa-search fs-xl"></i>
					<span class="menu-title">درج آگهی کاریابی</span>
				</a>
				<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/agent/ads" title="آگهی‌های کاریابی">
					<i class="fa fa-search fs-xl"></i>
					<span class="menu-title">آگهی‌های کاریابی</span>
				</a>
			</ng-container>
			<ng-container *ngIf="user?.Publisher">
				<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/board/list" title="جاب بوردها">
					<i class="fa fa-newspaper fs-xl"></i>
					<span class="menu-title">جاب بوردها</span>
				</a>
				<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/board/report" title="گزارش جاب بوردها">
					<i class="fa fa-chart-bar fs-xl"></i>
					<span class="menu-title">گزارش جاب بوردها</span>
				</a>
			</ng-container>

			<ng-container *ngIf="menuOpen && user?.Operator?.AccessRights?.length">
				<div class="py-2 border-top flex-fill d-flex flex-column overflow-auto">
					<a routerLink="/admin/activity">فعالیت‌ها</a>
					<a *ngIf="user.AccessRights.includes('ManageUsers')" routerLink="/admin/user">مدیریت کاربران</a>
					<a *ngIf="user.AccessRights.includes('ManageJobs')" routerLink="/admin/ads">مدیریت آگهی‌ها</a>
					<a routerLink="/admin/rtwad" *ngIf="user.IsOperator">مدیریت آماده به کار</a>
					<a *ngIf="user.AccessRights.includes('ManageDocuments')" routerLink="/admin/resource">مدیریت
						منابع</a>
						<a *ngIf="user.AccessRights.includes('ManagePayments')" routerLink="/admin/payments">مدیریت
							پرداخت‌ها</a>
					<a *ngIf="user.AccessRights.includes('ManageJobs')" routerLink="/admin/discount">کدهای تخفیف</a>
					<a routerLink="/admin/job-advertise">مدیریت تبلیغات آگهی</a>
					<a *ngIf="user.AccessRights.includes('ManageJobs')" routerLink="/admin/jobtitle">جاب تایتل</a>
					<a routerLink="/admin/organization">مدیریت شرکت‌ها</a>
					<a *ngIf="user.AccessRights.includes('ManageUsers')" routerLink="/admin/service-requests">درخواست‌های
						سرویس</a>
					<a *ngIf="user.AccessRights.includes('ManageJobs')" routerLink="/admin/job-booster">ارسال آگهی به
						کارجویان</a>
					<a *ngIf="user.AccessRights.includes('ManageJobs')" routerLink="/admin/ads/verify">تایید آگهی ها</a>
					<a *ngIf="user.AccessRights.includes('ManageJobs')" routerLink="/admin/ads/instagram">تایید
						اینستاگرام</a>
					<a *ngIf="user.AccessRights.includes('ManageJobs')" routerLink="/admin/ads/telegram">تلگرام</a>
					<a *ngIf="user.AccessRights.includes('ManageAgents')" routerLink="/admin/agent">مدیریت کاریابی‌ها</a>
					<a *ngIf="user.AccessRights.includes('ManagePayments')" routerLink="/admin/package">مدیریت پکیج‌ها</a>
					<a *ngIf="user.AccessRights.includes('ManageContents')" routerLink="/admin/content">مدیریت محتوا</a>
					<a *ngIf="user.AccessRights.includes('Reports')" routerLink="/monitoring/job-source">نمودار آگهی
						ها</a>
					<a *ngIf="user.AccessRights.includes('Reports')" routerLink="/monitoring/metrics">متریک ها</a>
					<a *ngIf="user.AccessRights.includes('Reports')" routerLink="/admin/stats-dashboard">داشبرد وضعیت</a>
					<a *ngIf="user.AccessRights.includes('Reports')" routerLink="/admin/kpi-dashboard">داشبرد KPI</a>
					<a *ngIf="user.AccessRights.includes('Reports')" routerLink="/admin/nps-report">گزارش NPS</a>
					<a *ngIf="user.AccessRights.includes('ManageUsers')" routerLink="/admin/insights">insights</a>
				</div>

			</ng-container>
		</ng-container>
		<ng-container *ngIf="panel=='employer'">
			<!-- <a routerLink="/employer/seekers" class="menu-item" [routerLinkActive]="['menu-active']"><i
          class="fas fa-users fs-xl"></i>
        <span class="menu-title">جستجو در رزومه کارجویان</span>
      </a> -->
			<ng-container *ngIf="user?.Employer">
				<a class="menu-item" [routerLinkActive]="['menu-active']" routerLink="/employer/seekers"
					title="جستجوی کارجویان (رزومه)">
					<i class="fa fa-address-book fs-xl"></i>
					<span class="menu-title">جستجوی کارجویان (رزومه)</span>
				</a>
				<a routerLink="/employer/applies" class="menu-item" [routerLinkActive]="['menu-active']"><i
						class="fa fa-address-book fs-xl"></i>
					<span class="menu-title">رزومه‌ها</span>
				</a>
				<a routerLink="/employer/ads" class="menu-item" [routerLinkActive]="['menu-active']"><i
						class="fa fa-bullhorn fs-xl"></i>
					<span class="menu-title">آگهی‌ها</span>
				</a>
				<a routerLink="/employer/company" class="menu-item" [routerLinkActive]="['menu-active']"><i
						class="fa fa-building fs-xl"></i>
					<span class="menu-title">اطلاعات شرکت</span>
				</a>
			</ng-container>
			<a routerLink="/" class="menu-item"><i class="fa fa-home fs-xl"></i>
				<span class="menu-title">سایت اصلی کارپیشه</span>
			</a>
			<div class="text-center">
				<a class="btn btn-primary" [class.btn-icon]="!menuOpen" routerLink="/employer/postad/flatrate">
					<i class="fa fa-plus fs-xl"></i>
					<span *ngIf="menuOpen" class="mr-2">ثبت آگهی استخدام</span>
				</a>
			</div>

		</ng-container>
	</nav>
</ng-template>
<ng-template #menuFooter>
	<footer class="flex-fill d-flex flex-column" *ngIf="menuOpen">
		<div class="pb-2 mt-auto sticky-bottom">
			<div class="p-2 text-center">
				<h6 class="kp-title-line">
					تماس با پشتیبانی
				</h6>
				<!-- <a class="m-1" href="tel:+982128429921">
          <span dir="ltr" class="d-inline-block text-left mr-2">021-28429921</span>
        </a>| -->
				<app-whatsapp-message mobile="2128429921" label="واتس‌اپ" text="سلام، نیاز به پشتیبانی دارم.">
				</app-whatsapp-message>
			</div>
			<div class="d-flex align-items-center justify-content-between px-3">
				<a class="f-hover-yellow" title="لینکداین کارپیشه" href="https://www.linkedin.com/company/karpishe"
					target="_blank"><i class="fab fa-linkedin text fs-xxl"></i></a>
				<a class="f-hover-yellow" title="تویتر کارپیشه" href="https://twitter.com/karpisheco" target="_blank"><i
						class="fab fa-twitter text fs-xxl"></i></a>
				<a class="f-hover-yellow" title="کانال تلگرام کارپیشه" href="https://t.me/estekhtam_channel" target="_blank"><i
						class="fab fa-telegram-plane text fs-xxl"></i></a>
				<a class="f-hover-yellow" title="اینستاگرام کارپیشه" href="https://www.instagram.com/karpisheh/"
					target="_blank"><i class="fab fa-instagram text fs-xxl"></i></a>
			</div>

		</div>
	</footer>

</ng-template>
